// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _SettingTwoTone = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/SettingTwoTone"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SettingTwoTone = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _SettingTwoTone.default
    }));
};
/**![setting](data:image/svg+xml;base64,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) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(SettingTwoTone);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'SettingTwoTone';
}
var _default = RefIcon;
